module.exports = "<ion-modal-view class=\"base-modal\" ng-class=\"::modalViewClassName\" ng-style=\"::modalViewStyle\">\n  <ion-view>templatePlaceholder</ion-view>\n</ion-modal-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/baseModal/baseModal.html
// module id = 95
// module chunks = 0